import { type StackPacksState, initialStackPacksState } from "./stackPacks/StackPacksState";
import { type WelcomeState, initialWelcomeState } from "./WelcomeSlice";

export interface PagesState {
	stackPacks: StackPacksState;
	welcome: WelcomeState;
}

export const initialPagesState: PagesState = {
	stackPacks: initialStackPacksState,
	welcome: initialWelcomeState,
};
